import { Box, Typography } from '@mui/material';
import { AUDITS_METADATA } from '@utils/audits';
import React from 'react';
import { IAudit } from 'types/audits';
import AuditCardItem from './AuditCardItem';
import AuditCardTextValue from './AuditCardTextValue';
import { AUDIT_DRAWER_FIELDS } from './constants';

interface IAuditCardProps {
	audit: IAudit;
}

const AuditCard: React.FC<IAuditCardProps> = ({ audit }) => {
	const message = AUDITS_METADATA[audit.action]?.message;

	return (
		<Box ml={1} data-testid="audit-card">
			<Typography variant="h6" fontWeight="bold">
				{message ? intl.tr(message) : audit.action}
			</Typography>
			{AUDIT_DRAWER_FIELDS.map(({ id, Component, valueSx }) => {
				const value = (audit as any)[id];
				return (
					value && (
						<AuditCardItem
							key={id}
							field={id}
							value={value}
							valueSx={valueSx}
							ComponentValue={Component || AuditCardTextValue}
						/>
					)
				);
			})}
		</Box>
	);
};

export default AuditCard;
